import { useToast } from '@/composables/useToast';

export const useRequestContentFormatting = () => {
  const { success, error } = useToast();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const formatStatus = (status: string) => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      case 'expired':
        return 'Expired';
      default:
        return status;
    }
  };

  const copyLink = async (link: string) => {
    try {
      await navigator.clipboard.writeText(link);
      success('Link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy link:', err);
      error('Failed to copy link to clipboard');
    }
  };

  return {
    formatDate,
    formatStatus,
    copyLink,
  };
};
